import PpcFilter from './filter/PpcFilter';
import PrequalState from './prequalify-modal/PrequalState';
import $ from 'cash-dom';

let instance = null;

/**
 * Manages and sends Alooma PPC Order Event.
 * Implements singleton pattern.
 */
class PpcPageOrderEventSender {
	constructor() {
		if (instance) {
			return instance;
		}

		this._hasFilters = PpcFilter.getInstance().hasFilters();
		this._prequalFilterApplied = false;
		this._prequalFilterAppliedTimeout = PpcFilter.getInstance().useArtificialWaiting
			? PpcFilter.getInstance().artificialWaitingTime + 100
			: 100;

		this._wasSent = false;

		instance = this;
	}

	/**
	 * @return {PpcPageOrderEventSender}
	 */
	static getInstance() {
		if (!instance) {
			instance = new PpcPageOrderEventSender();
		}

		return instance;
	}

	handle() {
		if (!this._hasFilters) {
			this._sendEvent();
			return;
		}

		$(document).on('PrequalifyModalHandler:prequalFilterApply', () => {
			this._prequalFilterApplied = true;

			setTimeout(() => {
				this._sendEvent();
			}, this._prequalFilterAppliedTimeout);
		});

		this._handlePrequalShowHide();
		this._handleNoPrequal();
		this._handleRedirect();
	}

	_sendEvent() {
		if (this._wasSent) {
			console.warn('Event was already sent');
			return;
		}

		const vendorsOrder = PpcFilter.getInstance().getVisibleVendorOrderData();

		Alooma.aloomaSendEvent('PPC Page order', {
			pageview_id: Alooma.aloomaPageData.pageview_id,
			url: window.location.href,
			vendorOrder: vendorsOrder,
			split_id: Alooma.aloomaPageData.split_id ?? null
		});

		this._wasSent = true;
	}

	_handlePrequalShowHide() {
		$(document).on('PrequalifyModalHandler:showPopup', () => {
			// handle hide only if it was showm
			$(document).on('PrequalifyModalHandler:prequalHide', () => {
				// use setTimeout 100 because PrequalifyModalHandler:prequalFilterApply is fired in setTimeout.
				// Also, it's needs some time for applying filters.
				setTimeout(() => {
					if (!this._prequalFilterApplied) {
						// prequal was hid without applying filters (e.g. user clicked popup close button)
						this._sendEvent()
					}
				}, 100);
			});
		});
	}

	_handleNoPrequal() {
		// we need some timeout to be sure that PrequalState.getInstance().noPrequal is set.
		setTimeout(() => {
			if (PrequalState.getInstance().noPrequal) {
				this._sendEvent();
			}

		}, 500)
	}

	_handleRedirect() {
		$(window).on('beforeunload', () => {
			this._sendEvent();
		});
	}
}

export default PpcPageOrderEventSender;